// The API answers a blocked caller with a translation key rather than a
// sentence, so the wording lives in the locale files
const MESSAGE_KEYS = {
  'messages.request.blocked': 'blocked.request',
  'messages.account.blocked': 'blocked.account',
};

// Empty string for every other error, so callers can fall back to their own wording
export default (error) => {
  if (error?.response?.status !== 403) return '';

  const detail = error.response._data?.detail;

  // Own keys only — a detail of `constructor` or `toString` would otherwise
  // reach into the prototype and hand $i18n.t a function instead of a key.
  // Not Object.hasOwn: the iOS target is 14.0 and that needs a 15.4 WKWebView,
  // so it would throw here instead of returning, on the SOS error path.
  if (!Object.prototype.hasOwnProperty.call(MESSAGE_KEYS, detail)) return '';

  return useNuxtApp().$i18n.t(MESSAGE_KEYS[detail]);
};

// How a block is shown, wherever one is shown: its wording carries the address to
// appeal to, so it waits to be dismissed — and grouped, or a second attempt would
// leave two on screen. Every other error keeps the caller's own duration.
export const blockedMessageOptions = (blocked, duration) => ({
  duration: blocked ? 0 : duration,
  grouping: !!blocked,
});
